import { FormErrorTranslations } from '@x/common/form';

export const SHOP_FORM_ERROR_TRANSLATIONS: FormErrorTranslations = {
  required: 'This is a required field.',
  emailInvalid: 'Please enter a valid email address.',
  minlength: ({ requiredLength }: { requiredLength: number }) =>
    `Please enter a min of ${requiredLength} characters.`,
  maxlength: ({ requiredLength }: { requiredLength: number }) =>
    `Character length must be shorter than or equal to ${requiredLength}.`,
  trimmed: `Please remove any spaces.`,
  noSpaces: `Please remove any spaces.`,
};
